import React from 'react';

interface TopNavProps {
  activePage?: string; // 'cambridge' | 'edexcel' | 'igcse' | 'disclaimer' | 'privacy' | 'terms' | 'cookies'
}

function TopNav({ activePage }: TopNavProps) {
  return (
    <div className="w-full bg-white border-b py-3" style={{ position: 'relative' }}>
      {/* Left-corner Potato group */}
      <div className="top-nav-left" aria-hidden="false">
        <a href="#/cambridgealevelpapers" className="top-nav-link home-link">「PotatoPapers」</a>
      </div>

      <div className="max-w-7xl mx-auto px-4">
        <nav className="top-nav flex items-center justify-center" aria-label="Top navigation">
          <div className="top-nav-center">
            <a href="#/cambridgealevelpapers" className="top-nav-link" style={activePage === 'cambridge' ? { fontWeight: 700, color: '#dc2626' } : {}}>Cambridge AS &amp; AL</a>
            <span className="sep">|</span>
            <a href="#/edexcelalevelpapers" className="top-nav-link" style={activePage === 'edexcel' ? { fontWeight: 700, color: '#dc2626' } : {}}>Edexcel International AL</a>
            <span className="sep">|</span>
            <a href="#/igcsepapers" className="top-nav-link" style={activePage === 'igcse' ? { fontWeight: 700, color: '#dc2626' } : {}}>IGCSE</a>
            <span className="sep">|</span>
            <span className="top-nav-link muted">AQA &amp; OCR <span className="text-gray-400 italic">Coming soon!</span></span>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default TopNav;
